<template>
    <div style="margin-left: 20px;" v-loading="loading">
        <el-form :model="form" :rules="rules" label-width="100px" ref="form" class="service-time" :key="box_id">
            <el-form-item label="日下载总次数限制：" label-width="203px" prop="day" class="limit-configure">
                总
                <el-input v-model="form.day.all" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.all}}</span>
                普
                <el-input v-model="form.day.pu" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.pu}}</span>
                精
                <el-input v-model="form.day.jing" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.jing}}</span>
                特
                <el-input v-model="form.day.te" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.te}}</span>
            </el-form-item>
            <el-form-item label="总下载次数限制：" prop="all" label-width="203px" class="limit-configure">
                总
                <el-input v-model="form.all.all" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption_all.all}}</span>
                普
                <el-input v-model="form.all.pu" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption_all.pu}}</span>
                精
                <el-input v-model="form.all.jing" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption_all.jing}}</span>
                特
                <el-input v-model="form.all.te" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption_all.te}}</span>
            </el-form-item>
            <el-form-item label="学币使用限制：" label-width="203px" prop="coin" class="limit-configure">
                总
                <el-input v-model="form.coin" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.coins}}</span>
                普
                <el-input v-model="form.pu" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.coin_pu}}</span>
                精
                <el-input v-model="form.jing" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.coin_jing}}</span>
                特
                <el-input v-model="form.te" type="number" :size="input_size" @input="emit"></el-input>
                <span style="color: red;">{{form.consumption.coin_te}}</span>
            </el-form-item>
            <el-form-item
                    label-width="200px"
                    v-for="(ip, index) in form.ips"
                    :label="'限制IP段：'"
                    :key="ip.key"
                    :prop="'ips.' + index "
                    :rules="rules.ip"
            >
                <div>
                    <el-col :span="5" style="float: left;">
                        <el-input size="mini" placeholder="开始IP：192.168.1.1" v-model="ip.start_ip"></el-input>
                    </el-col>
                    <el-col :span="8" style="float: left;margin-top: -2px">
                        <el-input size="mini" placeholder="结束IP：192.168.1.255" v-model="ip.end_ip">
                            <template slot="append">
                                <el-button type="danger" size="mini" v-if="index>0" @click.prevent="removeIp(ip)">删除
                                </el-button>
                                <el-button v-else size="mini" @click="addIp">新增IP</el-button>
                            </template>
                        </el-input>
                    </el-col>
                </div>
            </el-form-item>
            <el-form-item label="限制IP属地：" label-width="203px" class="limit-configure">
                <el-switch
                        v-model="form.restrict_ip"
                        active-text="开启"
                        inactive-text="关闭">
                </el-switch>
            </el-form-item>

            <el-form-item label="关联账号：" label-width="203px">
                <el-tag v-if="relationAccounts.length>0" style="margin-right: 5px"
                        :key="tag.uid"
                        v-for="tag in relationAccounts.slice(0,4)"

                        @close="handleCloseTag(tag)"
                        :disable-transitions="false">
                    {{tag.username}}
                </el-tag>
                <el-tag v-if="relationAccounts.length>4">...{{relationAccounts.length}}</el-tag>
                <el-button type="primary" icon="el-icon-circle-plus-outline" size="mini" @click="showRelation=true">
                    关联账号
                </el-button>
                <el-button type="primary" size="mini" @click="showAlreadyRelation">查看已关联账号</el-button>
                <relation-dialog ref="account" service="xwt" :key="box_id" :title="'关联账号'"
                                 :group_id="box_id" :customerId="$route.query['id']"
                                 @handleClose="closeRelationDialog" @relationAccount="relationAccount"
                                 :is-show="showRelation"></relation-dialog>
                <relation-dialog ref="relationAccount" service="xwt" :title="'已关联账号'"
                                 @removeAccount="removeAccount" :group_id="box_id" :already-relation="true"
                                 :customerId="$route.query['id']" @handleClose="closeRelationDialog"
                                 @relationAccount="relationAccount" :is-show="showIsAlreadyRelation"></relation-dialog>
            </el-form-item>
            <el-form-item label="备注：" label-width="203px" class="limit-configure">
                <el-input style="width: 300px;" type="textarea" v-model="form.memo" :size="input_size"
                          @input="emit"></el-input>
            </el-form-item>
            <el-form-item label="学科每日下载限制" label-width="140px" prop="batch">
                <el-button type="primary" icon="el-icon-download" size="mini" @click="dialogFormVisible=true">产品下载日志
                </el-button>
                <el-dialog title="下载日志" width="80%" :visible.sync="dialogFormVisible">
                    <xwt-log :is-dialog="true" :ztcId="box_id"></xwt-log>
                </el-dialog>
            </el-form-item>
            <el-table :data="form.batch" style="width: 100%;text-align: center;" class="limit-subject-configure">
                <el-table-column label="科目" style="text-align: center;">
                    <template slot-scope="scope">
                        <div>{{scope.row.subject_name}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="小学" style="text-align: center;">
                    <el-table-column label="普" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.primary.pu" type="number"
                                          @input="setLimit(scope.row.subject_id,'primary','pu')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'primary','pu')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="精" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.primary.jing" min="-1" type="number"
                                          @input="setLimit(scope.row.subject_id,'primary','jing')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'primary','jing')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="特" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.primary.te" type="number"
                                          @input="setLimit(scope.row.subject_id,'primary','te')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'primary','te')}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="初中" style="text-align: center;">
                    <el-table-column label="普" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.middle.pu" type="number"
                                          @input="setLimit(scope.row.subject_id,'middle','pu')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'middle','pu')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="精" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.middle.jing" type="number"
                                          @input="setLimit(scope.row.subject_id,'middle','jing')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'middle','jing')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="特" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.middle.te" type="number"
                                          @input="setLimit(scope.row.subject_id,'middle','te')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'middle','te')}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="高中" style="text-align: center;">
                    <el-table-column label="普" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.high.pu" type="number"
                                          @input="setLimit(scope.row.subject_id,'high','pu')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'high','pu')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="精" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.high.jing" type="number"
                                          @input="setLimit(scope.row.subject_id,'high','jing')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'high','jing')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="特" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.high.te" type="number"
                                          @input="setLimit(scope.row.subject_id,'high','te')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'high','te')}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="中职" style="text-align: center;">
                    <el-table-column label="普" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.vhs.pu" type="number"
                                          @input="setLimit(scope.row.subject_id,'vhs','pu')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'vhs','pu')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="精" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.vhs.jing" type="number"
                                          @input="setLimit(scope.row.subject_id,'vhs','jing')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'vhs','jing')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="特" style="text-align: center;">
                        <template slot-scope="scope">
                            <el-col :span="span_size">
                                <el-input v-model="scope.row.config.vhs.te" type="number"
                                          @input="setLimit(scope.row.subject_id,'vhs','te')"
                                          :size="input_size"></el-input>
                            </el-col>
                            <span style="color: red;">{{getConsumption(scope.row.subject_id,'vhs','te')}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>


<script>
    import Config from "~/config/params";
    import AccountService from "~/services/CustomerAccounts"
    import CustomerGroupService from "~/services/customerGroup";
    import ProductHead from "~/views/order/partial/product_head.vue";
    import RelationDialog from "~/views/customer/dialog/relationDialog.vue";
    import xwtLog from "~/views/log/xwt.vue";

    export default {
        components: {
            ProductHead,
            RelationDialog,
            xwtLog,
        },
        data() {
            let checkIp = (rule, value, callback) => {
                let ip = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
                if (value['start_ip'] || value['end_ip']) {
                    if (ip.test(value['start_ip']) && ip.test(value['end_ip'])) {
                        callback();
                    }
                    callback(new Error('请输入正确IP'));
                }
                callback();
            }
            let checkNumber = (rule, value, callback) => {
                if (typeof value['all'] == 'undefined') {
                    callback(new Error('请设置总额度'));
                }
                if (typeof value['pu'] == 'undefined') {
                    callback(new Error('请设置普通额度'));
                }
                if (typeof value['jing'] == 'undefined') {
                    callback(new Error('请设置精品额度'));
                }
                if (typeof value['te'] == 'undefined') {
                    callback(new Error('请设置特供额度'));
                }
                callback();
            }

            let checkCoin = (rule, value, callback) => {
                if (typeof this.form.coin == 'undefined') {
                    callback(new Error('请设置总学币额度'));
                }
                if (typeof this.form.pu == 'undefined') {
                    callback(new Error('请设置普通学币额度'));
                }
                if (typeof this.form.jing == 'undefined') {
                    callback(new Error('请设置精品学币额度'));
                }
                if (typeof this.form.te == 'undefined') {
                    callback(new Error('请设置特供学币额度'));
                }
                callback();
            }
            let checkBatch = (rule, value, callback) => {
                // value.forEach(item=>{
                //     if(item.subject_id != 0 ){
                //         if(typeof item.config.primary.jing =='undefined') callback(new Error('请设置小学精品额度'));
                //         if(typeof item.config.primary.pu =='undefined') callback(new Error('请设置小学普通额度'));
                //         if(typeof item.config.primary.te =='undefined') callback(new Error('请设置小学特供额度'));
                //         if(typeof item.config.middle.jing =='undefined') callback(new Error('请设置初中精品额度'));
                //         if(typeof item.config.middle.pu =='undefined') callback(new Error('请设置初中普通额度'));
                //         if(typeof item.config.middle.te =='undefined') callback(new Error('请设置初中特供额度'));
                //         if(typeof item.config.high.jing =='undefined') callback(new Error('请设置高中精品额度'));
                //         if(typeof item.config.high.pu =='undefined') callback(new Error('请设置高中普通额度'));
                //         if(typeof item.config.high.te =='undefined') callback(new Error('请设置高中特供额度'));
                //     }
                // })
                callback();
            }

            return {
                loading: true,
                input_size: 'mini',
                span_size: 16,
                relationAccounts: [],
                form: { //车厢表单
                    day: {
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: -1,
                    },
                    all: {
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: -1
                    },
                    coin: 0,
                    single: {
                        all: 0,
                        pu: 0,
                        jing: 0,
                        te: 0
                    },
                    jing: 0,
                    pu: 0,
                    te: -1,
                    memo: '',
                    restrict_ip:'',
                    batch: [],
                    ips: [
                        {start_ip: '', end_ip: ''}
                    ],
                    consumption: {
                        all: '',
                        pu: '',
                        jing: '',
                        te: '',
                        coins: '',
                        coin_pu: '',
                        coin_jing: '',
                        coin_te: '',
                    },
                    consumption_all: []
                },
                rules: {
                    ip: [
                        {validator: checkIp, trigger: 'blur'}
                    ],
                    'day': [
                        {validator: checkNumber, trigger: 'blur'},
                    ],
                    'all': [
                        {validator: checkNumber, trigger: 'blur'},
                    ],
                    'single': [
                        {validator: checkNumber, trigger: 'blur'},
                    ],
                    'coin': [
                        {validator: checkCoin, trigger: 'blur'},
                    ],
                    'batch': [
                        {validator: checkBatch, trigger: 'blur'},
                    ]
                },
                showRelationData: [],
                showIsAlreadyRelation: false,
                showRelation: false,
                formLabelWidth: '0px',
                dialogFormVisible: false,
                subjects: [],
                subjectParams: [],
            };
        },
        props: {
            box_id: {
                required: true
            },
            params: {
                required: true
            }
        },
        created() {
            this.getBoxConfig();
        },
        activated() {
            this.relationAccounts = [];
            this.getBoxAccounts();
        },
        beforeMount() {

        },
        mounted() {
            this.subjects = this.getSubjectConfig();
        },
        methods: {
            /**
             * 验证表单
             */
            validateForm(cb) {
                let flag = false;
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        flag = valid;
                    }
                    if (typeof cb === 'function') cb(flag)
                    return flag
                });
            },

            removeIp(item) {
                this.$confirm("确定要移除吗？", "温馨提示", {type: "warning"}).then(ok => {
                    var index = this.form.ips.indexOf(item)
                    if (index !== -1) {
                        this.form.ips.splice(index, 1)
                    }
                }).catch(cancel => {
                    return false;
                });
            },
            addIp() {
                this.form.ips.push({
                    start_ip: '',
                    end_ip: '',
                    key: Date.now()
                });
            },
            getConsumption(subject_id, xd, type) {
                if (!subject_id) return '';
                if (typeof this.form.batchConsumption == "undefined") return '';
                let consum = this.form.batchConsumption.find(i => {
                    return i.subject_id == subject_id
                });
                if (!consum) return 0;
                return consum['config'][xd][type];
            },
            /**
             * 获取车厢配置
             * */
            getBoxConfig() {

                CustomerGroupService.getBoxConfig(this.box_id).then(res => {
                    if (typeof res.data.batch != "undefined") {
                        this.form = res.data;
                        if(res.data.restrict_ip ==1) {
                            this.form.restrict_ip = true;
                        }else{
                            this.form.restrict_ip = false;
                        }
                        if (this.form.ips.length == 0) {
                            this.form.ips = [{start_ip: '', end_ip: ''}];
                        }
                    } else {
                        this.init_set_data();
                    }

                    this.emit();
                    this.loading = false;
                })
            },
            showAlreadyRelation() {
                this.showIsAlreadyRelation = true;
            },
            handleCloseTag(data) {
                this.relationAccounts = this.relationAccounts.filter(item => {
                    return item.uid != data.uid;
                })
            },
            /**
             * 关联账号
             * */
            relationAccount(data) {
                this.relationAccounts = data;
            },
            /**
             * 移除账号
             * */
            removeAccount(data) {
                this.relationAccounts = this.relationAccounts.filter(i => {
                    return i.user_id != data.user_id;
                })
            },
            closeRelationDialog(show) {
                this.showRelation = show;
                this.showIsAlreadyRelation = show;
            },
            // 初始化批量设置表单
            init_set_data() {
                this.form.batch = this.getSubjectConfig();
                this.form.day = this.get_init_num();

            },
            //日总额度，账号额度初始数据
            get_init_num() {
                return {
                    all: 0,
                    pu: this.params.open_state == Config.TYPE_TRY_OUT ? 50 : 0,
                    jing: this.params.open_state == Config.TYPE_TRY_OUT ? 50 : 0,
                    te: -1
                };
            },
            //账号额度初始数据
            get_init_account() {
                return {
                    pu: 0,
                    jing: 0,
                };
            },
            //科目批量设置重组
            getSubjectConfig() {
                this.subjects = this.getSubjects();
                this.subjects = this.subjects.map(item => {
                    item.config = this.get_init_config();
                    return item
                })
                return this.subjects;
            },
            //科目批量设置初始数据
            get_init_config() {
                let config = {
                    primary: {
                        pu: -1,
                        jing: -1,
                        te: -1
                    },
                    middle: {
                        pu: -1,
                        jing: -1,
                        te: -1
                    },
                    high: {
                        pu: -1,
                        jing: -1,
                        te: -1
                    },
                    vhs: {
                        pu: -1,
                        jing: -1,
                        te: -1
                    }
                }
                this.params.customer.periods.forEach(item => {
                    if (item == 1) {
                        config.primary.pu = this.params.open_state == Config.TYPE_TRY_OUT ? 20 : 0;
                        config.primary.jing = this.params.open_state == Config.TYPE_TRY_OUT ? 10 : 0;
                    } else if (item == 2) {
                        config.middle.pu = this.params.open_state == Config.TYPE_TRY_OUT ? 20 : 0;
                        config.middle.jing = this.params.open_state == Config.TYPE_TRY_OUT ? 10 : 0;
                    } else if (item == 3) {
                        config.high.pu = this.params.open_state == Config.TYPE_TRY_OUT ? 20 : 0;
                        config.high.jing = this.params.open_state == Config.TYPE_TRY_OUT ? 10 : 0;
                    } else if (item == 4) {
                        config.vhs.pu = this.params.open_state == Config.TYPE_TRY_OUT ? 20 : 0;
                        config.vhs.jing = this.params.open_state == Config.TYPE_TRY_OUT ? 10 : 0;
                    }
                })
                return config;
            },
            //获取科目
            getSubjects() {
                var subjects = Config.getSubjects();
                subjects.unshift({
                    subject_id: 0,
                    subject_name: '批量设置',
                });
                subjects = subjects.map(item => {
                    item.config = [];
                    return item;
                })
                return subjects;

            },
            /**@description 所有科目设置 */
            setLimit(val, stage, type) {
                if (val != 0) {  //所有科目选项
                    return false;
                }
                this.form.batch.forEach(item => {
                    let obj = this.form.batch[0].config;
                    let clone_obj = Object.assign({}, obj[stage]);
                    item.config[stage][type] = clone_obj[type];
                });
                this.emit();
            },
            //获取动态tab配置
            getDynamicConfig() {
                return {
                    day: Object.assign({}, this.form.day),
                    account: Object.assign({}, this.form.account),
                    batch: JSON.parse(JSON.stringify(this.form.batch)),
                    all: JSON.parse(JSON.stringify(this.form.all)),
                };
            },
            getBoxAccounts() {
                AccountService.accountFilter({
                    customer_id: this.params.customer_id,
                    service: 'xwt',
                    group_id: this.box_id,
                    perPage: 10000
                }).then(res => {
                    if (res.data) {
                        this.relationAccounts = [];
                        this.relationAccounts = res.data;
                        this.loading = false;
                        this.emit();
                    }
                })
            },
            emit() {
                this.$emit('updateBoxForm', this.form);
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/xwtBox.vue